import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation(); 
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleLogout = () => {
    setIsMenuOpen(false);
    logout();
    navigate('/login');
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const isActive = (path) => location.pathname === path ? 'nav-link active' : 'nav-link';
  const logoLink = user ? '/app' : '/';

  return (
    <nav className="navbar">
      <div className="navbar-container">
        
        {/* LOGO */}
        <Link to={logoLink} className="nav-logo" onClick={closeMenu}>
          <img src="/logo.png" alt="LuxerAssess" className="nav-logo-img" />
        </Link>

        {/* Hamburger Icon */}
        <div className={`menu-icon ${isMenuOpen ? 'open' : ''}`} onClick={toggleMenu}>
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </div>

        {/* Menu Links */}
        <div className={`nav-elements ${isMenuOpen ? 'active' : ''}`}>
          
          {user ? (
            // --- LOGGED IN VIEW ---
            <>
              <div className="nav-menu-links">
                <Link to="/app" className={isActive('/app')} onClick={closeMenu}>New Assessment</Link>
                <Link to="/dashboard" className={isActive('/dashboard')} onClick={closeMenu}>Dashboard</Link>
                <Link to="/profile" className={isActive('/profile')} onClick={closeMenu}>Settings</Link>
              </div>

              <div className="nav-right-elements">
                <div className="nav-user-badge">
                  <span className="user-email">{user.email}</span>
                  <span className="credit-count">{user.credit_balance} Credits</span>
                </div>
                
                <Link to="/billing" className="buy-credits-btn" onClick={closeMenu}>Buy Credits</Link>
                <button onClick={handleLogout} className="logout-btn">Logout</button>
              </div>
            </>
          ) : (
            // --- LOGGED OUT VIEW ---
            <div className="nav-right-elements">
               {/* 1. Added 'mobile-only' class here */}
               <Link 
                 to="/how-it-works" 
                 className={`${isActive('/how-it-works')} mobile-only`} 
                 onClick={closeMenu}
               >
                 How it Works
               </Link>
               
               <Link to="/login" className="nav-link" onClick={closeMenu}>Login</Link>
               <Link to="/signup" className="signup-btn" onClick={closeMenu}>Get Started</Link>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
}

export default Navbar;